import * as React from 'react'

import { Box, NumberBadge, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import type { Competency } from 'modules/competencies/store/models/Competency'

interface Props {
  competency: Competency
  onClose: () => void
}

const CompetencyDetail: React.FC<Props> = ({ competency, onClose }) => {
  const values = competency.optionsWithDescription.map((option) => {
    return (
      <Box key={option.attributes.id} flexDirection="row" gap="s16">
        <Box minWidth="s24">
          <NumberBadge
            label={option.attributes.value}
            color="viridian200"
            textColor="viridian1200"
          />
        </Box>
        <Text.Normal>{option.attributes.description}</Text.Normal>
      </Box>
    )
  })

  if (!competency.attributes.description && values.length === 0) {
    return null
  }

  return (
    <Modal title={competency.attributes.name} illustration="window-user" onClose={onClose}>
      <Box gap="s24" aria-label="competency-details">
        {competency.attributes.description && (
          <Text.Normal>{competency.attributes.description}</Text.Normal>
        )}
        {values.length > 0 && (
          <Box flexDirection="column" gap="s8">
            <Text.Normal size="200" weight="medium">
              {i18n.t('competencies_v2.assessments.competency_info.values')}
            </Text.Normal>
            <Box gap="s24">{values}</Box>
          </Box>
        )}
      </Box>
    </Modal>
  )
}

export default observer(CompetencyDetail)
